import { uploadWarrantComponent } from './uploadWarrant.component';
import { transferringStateName } from '../../../tickets.state';
import { TicketService } from '../../../../ticket/ticket.service';

export const uploadWarrantStateName = `${transferringStateName}.uploadWarrant`;

export const uploadWarrantState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: uploadWarrantStateName,
    url: '/upload/:ticketId',
    params: {
      ticketId: null // optional
    },
    component: uploadWarrantComponent.name,
    data: { requiresAuth: true },
    resolve: {
      ticket: TicketService.ticket({optional: true}),
      stateIndex: () => 0 // First step for a new transferring request ticket
    }
  });
};
